import { Helmet } from 'react-helmet-async';
import Layout from '../components/layout/Layout';
import ImprintContent from '../components/legal/ImprintContent';

const Imprint = () => {
  return (
    <Layout>
      <Helmet>
        <title>Imprint - Simons Marketing Solutions</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50 py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-xl p-8">
            <ImprintContent />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Imprint;